import { stringify } from 'qs';
import { SERVER_URL, PAGE_SIZE } from 'constants/index';

const getCatalogProducts = (
    currentCategory,
    currentPage,
    updateCatalogState
) => {
    let queryCatalog = {
        searchCriteria: {
            page_size: PAGE_SIZE,
            current_page: currentPage,
            filter_groups: [
                {
                    filters: [
                        {
                            field: 'category_id',
                            value: currentCategory,
                            condition_type: 'eq'
                        },

                        {
                            field: 'type_id',
                            value: 'simple',
                            condition_type: 'eq'
                        }
                    ]
                }
            ]
        }
    };

    queryCatalog = stringify(queryCatalog);
    fetch(SERVER_URL + 'products?' + queryCatalog)
        .then(response => response.json())
        .then(json => {
            updateCatalogState({
                catalogProducts: json.items,
                isLoading: false,
                catalogSize: json.total_count,
                pageSize: PAGE_SIZE
            });
        })
        .catch(error => console.error(error));
};

export { getCatalogProducts };



// WEBPACK FOOTER //
// ./src/modules/Catalog/actions/getCatalogProducts.js